import React from "react";
import { useBreakpoints, useTheme } from "../../hooks";
import { StatusDrawerThemeType } from "../../types";
import { Icon } from "../icon";
import { StatusDrawerHeaderContainer } from "./StatusDrawerStyles";

type StatusDrawerHeaderProps = {
  isOpen: boolean;
  onClick?: (value: boolean) => void;
  onClose?: () => void;
  styles?: StatusDrawerThemeType;
};

const StatusDrawerHeader: React.FC<React.PropsWithChildren<StatusDrawerHeaderProps>> = ({
  children,
  isOpen,
  onClick,
  onClose,
  styles = {},
}) => {
  const { Theme } = useTheme();
  const { isMobile } = useBreakpoints();
  const StylesOverride: StatusDrawerThemeType = { ...Theme.statusDrawer, ...styles };

  return (
    <StatusDrawerHeaderContainer
      styles={StylesOverride}
      onClick={() => {
        if (!!onClick) {
          onClick(!open);
        }
      }}
    >
      <div className="d-flex">
        <div className="ms-1">{children}</div>
        <div className="ms-auto">
          <div className="d-flex">
            {!isMobile && (
              <>
                <Icon
                  className="me-2"
                  iconName={isOpen ? "fa-angle-down" : "fa-angle-up"}
                  styles={{
                    ...Theme.icon,
                    color: Theme.colors.white,
                    hoverColor: Theme.colors["dark-grey"],
                  }}
                />
                {!!onClose && (
                  <Icon
                    onClick={onClose}
                    className="me-2"
                    iconName="fa-times"
                    styles={{
                      ...Theme.icon,
                      color: Theme.colors.white,
                      hoverColor: Theme.colors["dark-grey"],
                    }}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </StatusDrawerHeaderContainer>
  );
};

export default StatusDrawerHeader;
